import { render, staticRenderFns } from "./StyleQuick.vue?vue&type=template&id=c68d85d6&scoped=true"
import script from "./StyleQuick.vue?vue&type=script&lang=js"
export * from "./StyleQuick.vue?vue&type=script&lang=js"
import style0 from "./StyleQuick.vue?vue&type=style&index=0&id=c68d85d6&prod&lang=scss&scoped=true"
import style1 from "./StyleQuick.vue?vue&type=style&index=1&id=c68d85d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68d85d6",
  null
  
)

export default component.exports